/////////////////// ※주의: 루쿠쿠 편집 금지
/////////////////// ※warning: do not edit this file in lukuku

///////////////////  살로몬 전용 퍼블리셔 커스텀 스크립트  ///////////////////
///////////////////  salomon only publisher custom script  ///////////////////

///////////////////  페이지 전용  ///////////////////
$(function(){
  // 260923 JISOO 기획전
  if ($('#htmlCustom260922').length) {
    gsap.registerPlugin(ScrollTrigger);
    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) document.fonts.ready.then(scheduleLayoutRefresh);

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
    const resolveValue = (v) => (typeof v === 'function' ? v() : v);

    // cover - 배경 이미지 줌아웃 & 타이틀 등장
    const heroVid = document.querySelector('.js__hero');
    const navBtns = document.querySelectorAll('.nav__btn');
    const controlsBtn = document.querySelector('.js__video__controls');
    const coverPanel = document.querySelector('.js__collection__cover--panel');
    const progressFill = document.querySelector('.js__collection__progress__bar .fill');

    const HERO_VID_RATE = 0.91; // 영상 재생속도 0.9배속

    // 뷰포트별 소스 교체 - <source media>는 브라우저가 무시하거나 리사이즈 때 재선택하지 않음
    heroVid.poster = isMobile() ? heroVid.dataset.posterM : heroVid.dataset.poster;
    heroVid.querySelector('source').src = isMobile() ? heroVid.dataset.srcM : heroVid.dataset.src;
    heroVid.load();
    heroVid.defaultPlaybackRate = HERO_VID_RATE; // load()로 새 소스를 물리면 playbackRate가 default로 되돌아감
    heroVid.playbackRate = HERO_VID_RATE;

    const coverTl = gsap.timeline({ paused: true });
    const heroTl = gsap.timeline({ paused: true });

    // 진행바는 트윈 duration으로 영상 길이를 흉내내지 않고 실제 재생 위치를 매 프레임 반영 -
    // 버퍼링·배속·loop 시점이 어긋나지 않고, 영상이 처음으로 되감길 때 진행바도 같이 0부터 다시 채워짐
    const syncProgressToVid = () => {
      if (!heroVid.duration) return;
      gsap.set(progressFill, { width: `${(heroVid.currentTime / heroVid.duration) * 100}%` });
    };

    // play가 아닌 playing - 실제로 프레임이 나오기 시작한 시점부터 진행바가 움직여야 함
    heroVid.addEventListener('playing', () => {
      gsap.ticker.remove(syncProgressToVid); // 버퍼링 후 재개 때마다 중복 등록되는 것 방지
      gsap.ticker.add(syncProgressToVid);
    });
    heroVid.addEventListener('pause', () => gsap.ticker.remove(syncProgressToVid));

    coverTl
      .from('.js__collection__cover--vis', { scale: 1.3, duration: 5 }, 0)
      .to(coverPanel, { scale: 1.4, duration: 2, ease: 'power2.out' }, 0)
      .to(coverPanel, { autoAlpha: 0.4, duration: 3 }, 0.4)
      .to('.js__collection__cover--ttl', { autoAlpha: 0, duration: 0.6 }, 2)
      .to('.js__collection__cover--vis', { autoAlpha: 0, duration: 1, onStart: () => heroTl.play() }, 2.4);

    heroTl
      .call(() => heroVid.play(), null, 0)
      .from(navBtns, { y: -40, autoAlpha: 0, stagger: 0.2, duration: 0.6, ease: 'power2.out' }, 0.4)
      .from('.js__collection__progress', { y: 40, autoAlpha: 0, duration: 1, ease: 'power2.out' }, 1);

    // 탭 - VIDEO / CAMPAIGN / PRODUCTS 패널 전환
    const panels = ['video', 'campaign', 'products'].map((key) => document.querySelector(`.js__collection__panel--${key}`));
    const slideTotals = panels.map((panel) => panel.querySelectorAll('.swiper-slide').length);
    const swipers = []; // campaign(1) / products(2), 동적 import 이후 채워짐
    let activeIdx = 0;
    let progressSyncTw;

    // css의 opacity:0만으론 비활성 패널이 위에 덮인 채 swiper 드래그·클릭을 가로채므로 visibility까지 내림
    gsap.set(panels.slice(1), { autoAlpha: 0 });
    navBtns[0].classList.add('on');

    // progress 역할 전환 - video는 재생 진행률, swiper 탭은 현재 슬라이드 순서(pagination)
    const syncProgressToSlide = (idx, fromStart) => {
      const swiper = swipers[idx];
      if (!swiper) return;
      if (progressSyncTw) progressSyncTw.kill();
      const vars = { width: `${((swiper.realIndex + 1) / slideTotals[idx]) * 100}%`, duration: 1, ease: 'power2.out' };
      progressSyncTw = fromStart ? gsap.fromTo(progressFill, { width: '0%' }, vars) : gsap.to(progressFill, vars);
    };

    const activateTab = (idx) => {
      if (idx === activeIdx) return;

      navBtns[activeIdx].classList.remove('on');
      navBtns[idx].classList.add('on');
      gsap.to(panels[activeIdx], { autoAlpha: 0, duration: 0.6 });
      gsap.to(panels[idx], { autoAlpha: 1, duration: 0.6 });

      if (activeIdx === 0) {
        heroVid.pause();
      } else if (swipers[activeIdx]) {
        swipers[activeIdx].autoplay.stop();
      }

      activeIdx = idx;
      controlsBtn.classList.remove('pause');

      if (idx === 0) {
        if (progressSyncTw) progressSyncTw.kill(); // 남아 있으면 pagination 트윈이 같은 width를 동시에 씀
        heroVid.currentTime = 0;
        heroVid.play();

        gsap.to(coverPanel, { autoAlpha: 0.4, duration: 0.6, ease: 'none' });
        gsap.to(controlsBtn, { autoAlpha: 1, duration: 0.6, ease: 'none' });
      } else if (swipers[idx]) {
        swipers[idx].slideToLoop(0, 0);
        swipers[idx].autoplay.start();
        syncProgressToSlide(idx, true);

        gsap.to(coverPanel, { autoAlpha: 0, duration: 0.6, ease: 'none' });
        gsap.to(controlsBtn, { autoAlpha: 0, duration: 0.6, ease: 'none' });
      }
    };

    navBtns.forEach((btn, idx) => btn.addEventListener('click', () => activateTab(idx)));

    // 재생/일시정지 버튼 - 활성 탭에 따라 영상과 swiper autoplay 중 하나를 토글
    controlsBtn.addEventListener('click', () => {
      const resume = controlsBtn.classList.contains('pause');
      controlsBtn.classList.toggle('pause', !resume);

      if (activeIdx === 0) {
        if (resume) heroVid.play();
        else heroVid.pause();
      } else if (swipers[activeIdx]) {
        if (resume) swipers[activeIdx].autoplay.start();
        else swipers[activeIdx].autoplay.stop();
      }
    });

    // cover - 이미지 로딩 시 coverTl 실행
    const coverImg = document.querySelector('.js__collection__cover--vis img');
    const playCover = () => gsap.delayedCall(0, () => coverTl.play());
    if (coverImg && !(coverImg.complete && coverImg.naturalWidth)) coverImg.addEventListener('load', playCover, { once: true });
    else playCover();

    // Campaign / Product - Swiper
    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      [1, 2].forEach((idx) => {
        swipers[idx] = new Swiper(panels[idx], {
          loop: true,
          slidesPerView: 1,
          autoplay: {
            delay: 4500,
          },
          effect: 'fade',
          speed: 600,
          on: {
            slideChange() {
              if (activeIdx === idx) syncProgressToSlide(idx);
            },
          },
        });

        swipers[idx].autoplay.stop(); // 해당 탭이 활성화될 때까지 대기
      });

      // import 완료 전에 탭을 옮겼을 수 있음
      if (activeIdx !== 0) {
        swipers[activeIdx].autoplay.start();
        syncProgressToSlide(activeIdx);
      }
    });
  }

  // 260910 XT-KOREA GTX 기획전
  if ($('#htmlCustom260910').length) {
    gsap.registerPlugin(ScrollTrigger, SplitText);

    // 레이아웃·폰트 로드로 높이가 바뀌면 ScrollTrigger 좌표 재계산
    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) document.fonts.ready.then(scheduleLayoutRefresh);

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
    const resolveValue = (v) => (typeof v === 'function' ? v() : v);

    // hero - 배경 이미지와 타이틀이 블러에서 선명해지며 등장
    const heroTl = gsap.timeline({ paused: true });
    let heroTtlPlayed = false;

    SplitText.create('.kr__hero__ttl h1, .kr__hero__ttl p', {
      type: 'chars',
      mask: 'chars',
      autoSplit: true,
      onSplit(self) {
        if (heroTtlPlayed) {
          gsap.set(self.chars, { autoAlpha: 1, filter: 'blur(0px)' });
          return;
        }

        gsap.set(self.chars, { autoAlpha: 0, filter: 'blur(20px)' });
        heroTl.to(
          self.chars,
          {
            autoAlpha: 1,
            filter: 'blur(0px)',
            duration: 1.2,
            ease: 'power2.out',
            onComplete: () => (heroTtlPlayed = true),
          },
          1
        );
      },
    });

    gsap.set('.kr__hero picture img', { scale: 1.2, filter: `blur(${isMobile() ? 10 : 14}px)` });

    heroTl
      .to('.kr__hero picture img', { filter: 'blur(0px)', duration: 2, ease: 'power2.out' }, 0)
      .to('.kr__hero picture img', { scale: 1, duration: 1.2 }, 0)
      .to('.kr__hero__dimmed', { autoAlpha: 1 }, 0.8);

    const heroImg = document.querySelector('.kr__hero img');
    const playHero = () => gsap.delayedCall(0, () => heroTl.play());
    if (heroImg && !(heroImg.complete && heroImg.naturalWidth)) heroImg.addEventListener('load', playHero, { once: true });
    else playHero();

    // visual - 모델 컷과 메인 컷 스크롤 리빌
    gsap.utils.toArray('.kr__vis__item').forEach((el) => {
      gsap.from(el, { autoAlpha: 0, duration: 0.8, scrollTrigger: { trigger: el, start: 'top center' } });
    });

    gsap.from('.kr__vis__main', { yPercent: 2, filter: 'blur(10px)', autoAlpha: 0, duration: 1.2, scrollTrigger: { trigger: '.kr__vis__main', start: 'top top' } });

    // worker / rover - 컨테이너를 스크럽으로 흘리면서 내부 아이템과 타이틀을 순차적으로 리빌
    const workerEl = document.querySelector('.kr__worker');
    const roverEl = document.querySelector('.kr__rover');
    const workerInner = document.querySelector('.kr__worker__inner');
    const roverInner = document.querySelector('.kr__rover__inner');
    const workerItems = gsap.utils.toArray('.kr__worker__item');
    const roverItems = gsap.utils.toArray('.kr__rover__item');

    const workerToY = () => (isMobile() ? -30 : -40);
    const roverFromY = () => (isMobile() ? 30 : 50);
    const dimmedFromY = () => (isMobile() ? 10 : 50);

    gsap.set('.kr__vis__dimmed', { autoAlpha: 0, yPercent: dimmedFromY });
    gsap.set([...workerItems, ...roverItems], { yPercent: 10, autoAlpha: 0, filter: 'blur(6px)' });

    // __inner가 스크럽으로 밀린 만큼 아이템 발화 지점이 어긋나므로 절대 스크롤 좌표로 역산
    function resolveItemStart(container, el, viewportStart, motion) {
      const base = gsap.utils.toArray(container)[0];
      if (!base || !el) return 0;

      const vs = resolveValue(viewportStart);
      const ratio = typeof vs === 'number' ? vs : parseFloat(vs) / 100;
      const threshold = window.innerHeight * ratio;
      const itemTop = base.getBoundingClientRect().top + window.scrollY + el.offsetTop;
      const st = motion && motion.scrollTrigger;
      const range = st ? st.end - st.start : 0;
      if (!range) return itemTop - threshold;

      const innerHeight = motion.inner.offsetHeight;
      const fromPx = (innerHeight * resolveValue(motion.fromYPercent)) / 100;
      const toPx = (innerHeight * resolveValue(motion.toYPercent)) / 100;
      const k = (toPx - fromPx) / range;
      const scrollY = (itemTop + fromPx - threshold - k * st.start) / (1 - k);

      // 섹션 스크럽이 시작하기도 전에 아이템이 먼저 뜨면 어색하므로 섹션 start를 하한으로 둠
      if (scrollY < st.start) return Math.max(itemTop + fromPx - threshold, st.start);
      if (scrollY > st.end) return itemTop + toPx - threshold;
      return scrollY;
    }

    function revealItemsSequentially(container, items, viewportStart, motion) {
      items.forEach((el) => {
        const men = el.querySelector('.men');

        gsap.to(el, {
          yPercent: 0,
          autoAlpha: 1,
          filter: 'blur(0px)',
          duration: 1.2,
          ease: 'power2.out',
          onComplete: () =>
            men &&
            gsap.to(men, {
              autoAlpha: 1,
              duration: 1,
              ease: 'power2.inOut',
              repeat: -1,
              yoyo: true,
              delay: isMobile() ? 0.3 : 0.6,
              repeatDelay: isMobile() ? 1.2 : 2,
            }),
          scrollTrigger: {
            trigger: container,
            start: () => resolveItemStart(container, el, viewportStart, motion),
            invalidateOnRefresh: true,
          },
        });
      });
    }

    function revealTitleLines(container, ttl, viewportStart, motion) {
      if (!ttl) return;
      let played = false;

      SplitText.create(ttl.querySelectorAll('h3, p'), {
        type: 'lines',
        mask: 'lines',
        autoSplit: true,
        onSplit(self) {
          if (played) {
            gsap.set(self.lines, { yPercent: 0 });
            return;
          }

          gsap.set(self.lines, { yPercent: 100 });
          return gsap.to(self.lines, {
            yPercent: 0,
            duration: 1,
            stagger: 0.3,
            ease: 'power2.out',
            onComplete: () => (played = true),
            scrollTrigger: {
              trigger: container,
              start: () => resolveItemStart(container, ttl, viewportStart, motion),
              invalidateOnRefresh: true,
            },
          });
        },
      });
    }

    const workerTl = gsap
      .timeline({
        scrollTrigger: {
          trigger: workerEl,
          start: 'top 80%',
          end: 'bottom 80%',
          scrub: true,
          invalidateOnRefresh: true,
          onEnter: () => {
            gsap.to('.kr__vis__dimmed--blk', { autoAlpha: 1, yPercent: 0, duration: 0.8 });
          },
        },
      })
      .to(workerInner, { yPercent: workerToY, ease: 'none', duration: 1 }, 0);

    const workerMotion = {
      scrollTrigger: workerTl.scrollTrigger,
      inner: workerInner,
      fromYPercent: 0,
      toYPercent: workerToY,
    };
    revealItemsSequentially(workerEl, workerItems, '50%', workerMotion);
    revealTitleLines(workerEl, workerEl.querySelector('.kr__worker__ttl'), '50%', workerMotion);

    const roverTl = gsap
      .timeline({
        scrollTrigger: {
          trigger: roverEl,
          start: () => (isMobile() ? '30% 80%' : 'top top'),
          end: 'bottom bottom',
          scrub: true,
          invalidateOnRefresh: true,
          onEnter: () => {
            gsap.to('.kr__vis__dimmed--wht', { autoAlpha: 1, yPercent: 0, duration: 0.8 });
          },
          onLeaveBack: () => {
            gsap.to('.kr__vis__dimmed--wht', { autoAlpha: 0, yPercent: dimmedFromY, duration: 0.5 });
          },
        },
      })
      .fromTo(roverInner, { yPercent: roverFromY }, { yPercent: 0, ease: 'none', duration: 1 }, 0);

    const roverMotion = {
      scrollTrigger: roverTl.scrollTrigger,
      inner: roverInner,
      fromYPercent: roverFromY,
      toYPercent: 0,
    };
    revealItemsSequentially(roverEl, roverItems, '80%', roverMotion);
    revealTitleLines(roverEl, roverEl.querySelector('.kr__rover__ttl'), '80%', roverMotion);
  }

  // 260908 그래블러닝 미러링
  if ($('#htmlCustom260908').length) {
    gsap.registerPlugin(ScrollTrigger);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });

    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) {
      document.fonts.ready.then(scheduleLayoutRefresh);
    }

    // 여러 섹션에서 반복되는 페이드업 리빌 애니메이션
    function revealAni(containerSelector, childSelector, vars = {}) {
      gsap.utils.toArray(containerSelector).forEach((container) => {
        const targets = container.querySelectorAll(childSelector);
        if (!targets.length) return;

        gsap.set(targets, { autoAlpha: 0, y: 40 });
        gsap.to(targets, {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: { trigger: container, start: 'top 85%' },
          ...vars,
        });
      });
    }

    // 히어로 : 텍스트 없이 이미지만 진입 시 스케일업
    const heroImg = document.querySelector('.gravel__hero img');
    const playHero = () => gsap.from('.gravel__hero img', { scale: 1.2, duration: 1.4, ease: 'power2.out' });
    if (heroImg) {
      if (heroImg.complete && heroImg.naturalWidth !== 0) {
        playHero();
      } else {
        heroImg.addEventListener('load', playHero, { once: true });
      }
    }

    // 이미지 클립 리빌 공통 트윈
    function revealImg(img, scrollTrigger) {
      gsap.fromTo(img, { scale: 1.1 }, { scale: 1, ease: 'none', scrollTrigger });
    }

    // 가로 스크롤 pin
    function createHorzTrack({ section, track, ttl = null, firstCount, firstRevealStart = 'top 70%', scrollRatio = 0.5 }) {
      const targets = ttl ? [track, ttl] : track;
      const dist = track.scrollWidth - window.innerWidth;
      const scrollDist = dist * scrollRatio;

      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            pin: true,
            scrub: 0.5,
            start: 'center center',
            end: () => '+=' + scrollDist,
            invalidateOnRefresh: true,
          },
        })
        .to(targets, { x: -dist, ease: 'power1.inOut' }, 0);

      const imgs = gsap.utils.toArray(track.querySelectorAll('img, video'));
      const firstImgs = imgs.slice(0, firstCount);
      const restImgs = imgs.slice(firstCount);

      firstImgs.forEach((img) => revealImg(img, { trigger: section, start: firstRevealStart, end: 'center center' }));
      gsap.to('.gravel__track__item--1 .off', {
        clipPath: 'inset(0 0 0 0%)',
        duration: 1,
        scrollTrigger: { trigger: '.gravel__track__item--1 .off', start: 'top 25%', end: 'center 25%' },
      });
      restImgs.forEach((img) => revealImg(img, { containerAnimation: tl, trigger: img, start: 'left 80%', end: 'left 40%' }));
    }

    ScrollTrigger.matchMedia({
      '(min-width: 769px)': function () {
        createHorzTrack({
          section: document.querySelector('.gravel__track'),
          track: document.querySelector('.gravel__track__row'),
          firstCount: 2,
        });
      },

      '(max-width: 768px)': function () {
        createHorzTrack({
          section: document.querySelector('.gravel__track'),
          track: document.querySelector('.gravel__track__row'),
          firstCount: 1,
          scrollRatio: 1.2,
        });
      },
    });

    revealAni('.gravel__intro', 'h1, p');
    revealAni('.gravel__shop__lst', 'li', { stagger: 0.1 });
    revealAni('.gravel__inspire__ttl', 'h2, p', { stagger: 0 });
    revealAni('.gravel__bann__ttl', 'h2');
    gsap.to('.gravel__inspire .off', {
      clipPath: 'inset(0 0% 0 0)',
      duration: 1,
      scrollTrigger: { trigger: '.gravel__inspire .off', start: 'top 30%', end: 'center 30%' },
    });

    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      const mq = window.matchMedia('(max-width: 768px)');
      let inspireSwiper = null;
      let inspireAutoplayTrigger = null;

      function enter() {
        if (inspireSwiper) return;
        inspireSwiper = new Swiper('.gravel__inspire__swiper', {
          loop: true,
          slidesPerView: 1,
          autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          },
          speed: 800,
          effect: 'creative',
          creativeEffect: {
            prev: {
              translate: ['-60%', 0, -1],
            },
            next: {
              translate: ['100%', 0, 0],
            },
          },
          pagination: {
            el: '.gravel__inspire__swiper .swiper-pagination',
            clickable: true,
          },
        });

        inspireSwiper.autoplay.stop();
        inspireAutoplayTrigger = ScrollTrigger.create({
          trigger: '.gravel__inspire__swiper',
          start: 'top 70%',
          onEnter: () => inspireSwiper.autoplay.start(),
        });
      }

      function exit() {
        if (!inspireSwiper) return;
        inspireAutoplayTrigger?.kill();
        inspireAutoplayTrigger = null;
        inspireSwiper.destroy(true, true);
        inspireSwiper = null;
      }

      mq.addEventListener('change', (e) => (e.matches ? enter() : exit()));
      if (mq.matches) enter();
    });

    gsap.utils.toArray('.gravel__track video, .gravel__video video').forEach((vidEl) => {
      ScrollTrigger.create({
        trigger: vidEl,
        start: 'top 90%',
        onEnter: (self) => self.trigger.play(),
      });
    });

    window.addEventListener('load', () => ScrollTrigger.refresh());
  }

  //260819 제네시스2 GTWS 디벨롭
  if ($('#htmlCustom260814').length) {
    gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });

    const subEl = document.querySelector('.genesis__hero__ttl .sub');
    const h1El = document.querySelector('.genesis__hero__ttl h1');

    gsap.set(subEl, { y: 20, rotateX: '-87deg', autoAlpha: 0 });
    gsap.set(h1El, { y: 30, rotateX: '-87deg', autoAlpha: 0 });

    const introTl = gsap.timeline({ paused: true });

    introTl.to(subEl, { y: 0, rotateX: '0deg', autoAlpha: 1, duration: 0.7 }, 0);
    introTl.to(h1El, { y: 0, rotateX: '0deg', autoAlpha: 1, duration: 1, ease: 'power2.out' }, 0);

    function resetSimgState(svgScope) {
      gsap.set('.genesis__hero__vis .zoom', { scale: 0, autoAlpha: 0 });
      gsap.set('.genesis__hero__vis strong', { y: 20, autoAlpha: 0 });
      gsap.set(`.genesis__hero__vis ${svgScope} path`, { drawSVG: '100% 100%' });
      gsap.set(`.genesis__hero__vis ${svgScope} circle`, { scale: 0, transformOrigin: '50% 50%' });
    }

    function createSimgTl(container, svgScope) {
      const svg = container.querySelector(svgScope);
      const tl = gsap.timeline({ paused: true });
      tl.to(container.querySelector('.zoom'), { scale: 1, autoAlpha: 1, duration: 0.4 })
        .to(container.querySelector('strong'), { y: 0, autoAlpha: 1, duration: 0.3 }, '-=.1')
        .to(svg.querySelector('path'), { drawSVG: '0% 100%', duration: 0.5, ease: 'power2.inOut' })
        .to(svg.querySelector('circle'), { scale: 1, autoAlpha: 1, duration: 0.3 });

      return tl;
    }

    function createMobileSimgTl(simg1El, simg2El) {
      const simg1Svg = simg1El.querySelector('.mobile-only');
      const simg2Svg = simg2El.querySelector('.mobile-only');
      const tl = gsap.timeline({ paused: true });

      tl.to(simg1El.querySelector('.zoom'), { scale: 1, autoAlpha: 1, duration: 0.3 })
        .to(simg1El.querySelector('strong'), { y: 0, autoAlpha: 1, duration: 0.25 }, '-=.1')
        .to(simg1Svg.querySelector('path'), { drawSVG: '0% 100%', duration: 0.35, ease: 'power2.inOut' })
        .to(simg1Svg.querySelector('circle'), { scale: 1, autoAlpha: 1, duration: 0.2 })
        .to(simg1El, { autoAlpha: 0, duration: 0.2 }, '+=.6')
        .to(simg2El.querySelector('.zoom'), { scale: 1, autoAlpha: 1, duration: 0.3 }, '<')
        .to(simg2El.querySelector('strong'), { y: 0, autoAlpha: 1, duration: 0.25 }, '-=.1')
        .to(simg2Svg.querySelector('path'), { drawSVG: '0% 100%', duration: 0.35, ease: 'power2.inOut' })
        .to(simg2Svg.querySelector('circle'), { scale: 1, autoAlpha: 1, duration: 0.2 });

      return tl;
    }

    let heroTl;
    let simgSteps;

    function checkSimgSteps() {
      const elapsed = heroTl.time() - heroTl.labels.wide;
      simgSteps.forEach((step) => {
        if (elapsed >= step.offset && !step.revealed) {
          step.revealed = true;
          step.enter();
        } else if (elapsed < step.offset && step.revealed) {
          step.revealed = false;
          step.leave?.();
        }
      });
    }

    ScrollTrigger.matchMedia({
      '(min-width: 769px)': function () {
        resetSimgState('.desktop-only');

        const simg1El = document.querySelector('.simg1');
        const simg2El = document.querySelector('.simg2');
        const simg1Tl = createSimgTl(simg1El, '.desktop-only');
        const simg2Tl = createSimgTl(simg2El, '.desktop-only');
        const heroEl = document.querySelector('.genesis__hero');
        const visEl = document.querySelector('.genesis__hero__vis');

        const getPanYPercent = () => {
          const pannable = visEl.offsetHeight - heroEl.offsetHeight;
          return pannable > 0 ? -(pannable / visEl.offsetHeight) * 100 : 0;
        };

        // PC: simg1 노출 후 simg2가 그 위에 그대로 추가 노출(둘 다 유지)
        simgSteps = [
          { offset: 0, revealed: false, enter: () => simg1Tl.play(), leave: () => simg1Tl.reverse() },
          { offset: 0.9, revealed: false, enter: () => simg2Tl.play(), leave: () => simg2Tl.reverse() },
        ];

        heroTl = gsap.timeline({
          scrollTrigger: {
            trigger: '.genesis__hero',
            start: 'top top',
            pin: true,
            end: '200% bottom',
            scrub: 1,
            invalidateOnRefresh: true,
            onUpdate: checkSimgSteps,
          },
        });

        heroTl
          .to({}, { duration: 0.25 })
          .add('intro')
          .to('.genesis__hero__ttl', { yPercent: -100, autoAlpha: 0, duration: 0.3 }, 'intro')
          .to('.genesis__hero__vis', { top: 0, clipPath: 'inset(0 0vw 0)', duration: 0.7 }, 'intro')
          .add('wide')
          .to(visEl, { yPercent: getPanYPercent, duration: 2 }, 'wide')
          .to({}, { duration: 0.25 });

        return () => simgSteps.forEach((step) => (step.revealed = false));
      },
      '(max-width: 768px)': function () {
        resetSimgState('.mobile-only');

        const simg1El = document.querySelector('.simg1');
        const simg2El = document.querySelector('.simg2');
        const simgMobileTl = createMobileSimgTl(simg1El, simg2El);
        const heroEl = document.querySelector('.genesis__hero');
        const visEl = document.querySelector('.genesis__hero__vis');

        const getPanYPercent = () => {
          const pannable = visEl.offsetHeight - heroEl.offsetHeight;
          return pannable > 0 ? -(pannable / visEl.offsetHeight) * 100 : 0;
        };

        simgSteps = [{ offset: 0, revealed: false, enter: () => simgMobileTl.play() }];

        heroTl = gsap.timeline({
          scrollTrigger: {
            trigger: '.genesis__hero',
            start: 'top top',
            end: '150% top',
            pin: true,
            scrub: 1,
            invalidateOnRefresh: true,
            onUpdate: checkSimgSteps,
          },
        });

        heroTl
          .to({}, { duration: 0.25 })
          .add('intro')
          .to('.genesis__hero__ttl', { yPercent: -100, autoAlpha: 0, duration: 0.5 }, 'intro')
          .to(
            visEl,
            {
              top: 0,
              clipPath: 'inset(0vw 0vw 0vw)',
              duration: 0.5,
              onComplete: () => {
                visEl.classList.add('dimmed');
              },
            },
            'intro'
          )
          .add('wide')
          .to(
            {},
            {
              duration: 0.15,
              onReverseComplete: () => {
                visEl.classList.remove('dimmed');
              },
            }
          )
          .to(visEl, { yPercent: getPanYPercent, duration: 2, onReverseComplete: () => simgMobileTl.pause(0) }, 'wide')
          .to({}, { duration: 0.25 });

        return () => simgSteps.forEach((step) => (step.revealed = false));
      },
    });

    (function () {
      var mq = window.matchMedia('(max-width: 768px)');
      var seriesSwiper = null;

      function enter() {
        if (seriesSwiper) return;
        seriesSwiper = new Swiper('.genesis__series__swiper', {
          slidesPerView: 1,
          pagination: {
            el: '.genesis__series__swiper .swiper-pagination',
            clickable: true,
          },
        });
      }

      function exit() {
        if (!seriesSwiper) return;
        seriesSwiper.destroy(true, true);
        seriesSwiper = null;
      }

      mq.addEventListener('change', (e) => (e.matches ? enter() : exit()));
      if (mq.matches) enter();
    })();

    var heroImg = document.querySelector('.genesis__hero img');
    var playHeroTl = function () {
      gsap.delayedCall(0.5, () => introTl.play());
    };
    if (heroImg) {
      if (heroImg.complete && heroImg.naturalWidth !== 0) {
        playHeroTl();
      } else {
        heroImg.addEventListener(
          'load',
          () => {
            playHeroTl();
            ScrollTrigger.refresh(); // getPanYPercent가 로드된 이미지의 실제 높이로 다시 계산되게
          },
          { once: true }
        );
      }
    } else {
      playHeroTl();
    }

    // 링크 클릭 시 스크롤 부드럽게 이동
    let isClickScrolling = false;
    let clickScrollTimer = null;

    const tabLinks = document.querySelectorAll('.gtws__lst a');
    tabLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        isClickScrolling = true;
        clearTimeout(clickScrollTimer);

        if ('onscrollend' in window) {
          window.addEventListener(
            'scrollend',
            () => {
              isClickScrolling = false;
            },
            { once: true }
          );
        } else {
          clickScrollTimer = setTimeout(() => {
            isClickScrolling = false;
          }, 800);
        }
      });
    });
  }

  //260813 하이드레이션 GTWS 디벨롭
  if ($('#htmlCustom260813').length) {
    var finder = document.querySelector('.section-finder');
    if (!finder) return;

    var groups = Array.prototype.slice.call(finder.querySelectorAll('.fit-group'));
    var mq = window.matchMedia('(max-width: 768px)');
    var swiper = null;
    var root = null;

    function enter() {
      root = document.createElement('div');
      root.className = 'fit-swiper swiper';

      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      groups.forEach(function (group, i) {
        var titleClone = group.querySelector('.section-title').cloneNode(true);

        var grid = group.querySelector('.product-grid');
        Array.prototype.slice.call(grid.children).forEach(function (item) {
          item.dataset.fitGroup = i;

          var slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.appendChild(titleClone.cloneNode(true));
          slide.appendChild(item);
          wrapper.appendChild(slide);
        });
      });

      root.appendChild(wrapper);

      var pagination = document.createElement('div');
      pagination.className = 'swipe-pagination';
      root.appendChild(pagination);

      groups[groups.length - 1].after(root);

      swiper = new Swiper('.fit-swiper', {
        slidesPerView: 'auto',
        pagination: {
          el: '.swipe-pagination',
          clickable: true,
          bulletClass: 'dot',
          bulletActiveClass: 'active',
        },
      });
    }

    function exit() {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
      if (!root) return;

      groups.forEach(function (group, i) {
        var grid = group.querySelector('.product-grid');
        Array.prototype.slice.call(root.querySelectorAll('[data-fit-group="' + i + '"]')).forEach(function (item) {
          delete item.dataset.fitGroup;
          grid.appendChild(item);
        });
      });

      root.remove();
      root = null;
    }

    mq.addEventListener('change', function (e) {
      if (e.matches) enter();
      else exit();
    });

    if (mq.matches) enter();

    $(window).on('load', function () {
      gsap.to('.section-visual-ttl', { autoAlpha: 1, duration: 0.5 });
      gsap.to('.section-visual-ttl h1', { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.2 });
      gsap.to('.section-visual-ttl p', { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.2 });
    });

    $('.img-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      speed: 600,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      cssEase: 'linear',
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            swipe: true,
            draggable: true,
            touchMove: true,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        },
      ],
    });

    // preload="none" 영상은 뷰포트에 들어올 때만 재생 — data-video-src가 있으면 이 시점에 src 주입
    function playLazyVideo(video) {
      if (!video.src && video.dataset.videoSrc) {
        video.src = video.dataset.videoSrc;
        video.load();
      }
      video.play().catch((err) => {
        console.warn('영상 자동재생 실패:', err);
      });
    }

    document.querySelectorAll('video').forEach((video) => {
      ScrollTrigger.create({
        trigger: video,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: () => playLazyVideo(video),
      });
    });
  }

  //260731 S/LAB 기획전
  if ($('#htmlCustom260731').length) {
    gsap.registerPlugin(ScrollTrigger);
    const mm = gsap.matchMedia();

    // 리사이즈 시 ScrollTrigger 재계산
    ScrollTrigger.normalizeScroll(true);
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });
    gsap.to('.slab__hero__vis', { autoAlpha: 1, duration: 1.5 });
    const introLogoTween = gsap.to('.slab__hero__logo', { autoAlpha: 1, clipPath: 'inset(0 0% 0 0)', ease: 'none', duration: 0.75, delay: 0.5 });

    function createHeroTl(visYPercent) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.slab__hero',
          start: 'top top',
          end: 'bottom top',
          pin: true,
          scrub: 0.2,
        },
      });

      tl.to('.slab__hero__vis', { yPercent: visYPercent, ease: 'none', duration: 1.5 }, 0)
        .to(
          {},
          {
            onComplete: () => {
              gsap.to('.slab__hero__logo', { autoAlpha: 0, clipPath: 'inset(0 0 0 100%)', ease: 'none', duration: 0.2 });
            },
            onReverseComplete: () => {
              gsap.to('.slab__hero__logo', { autoAlpha: 1, clipPath: 'inset(0 0 0 0%)', ease: 'none', duration: 0.2 });
            },
          },
          0.4
        )
        .to(
          {},
          {
            onComplete: () => {
              gsap.to('.slab__hero__sub', {
                autoAlpha: 1,
                clipPath: 'inset(0 0% 0 0)',
                ease: 'none',
                duration: 0.5,
                onStart: () => {
                  introLogoTween.kill();
                },
              });
            },
            onReverseComplete: () => {
              gsap.to('.slab__hero__sub', { autoAlpha: 0, clipPath: 'inset(0 100% 0 0)', ease: 'none', duration: 0.2 });
            },
          },
          0.4
        )
        .to({}, { duration: 0.5 });

      return tl;
    }

    ScrollTrigger.matchMedia({
      '(min-width: 769px)': () => createHeroTl(-50),
      '(max-width: 768px)': () => createHeroTl(-36),
    });

    gsap.set('.slab__usp__item', { y: 50, clipPath: 'inset(0 0 100%)' });
    gsap.to('.slab__usp__item', {
      y: 0,
      clipPath: 'inset(0 0 0%)',
      duration: 0.5,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.slab__usp__list',
        start: 'top 80%',
      },
    });

    // 영상 스크롤 영역에 도달 시 재생
    gsap.utils.toArray('.slab video').forEach((vidEl) => {
      ScrollTrigger.create({
        trigger: vidEl,
        start: 'top 70%',
        onEnter: (self) => {
          self.trigger.play();
        },
      });
    });

    // 모바일 Swiper 영역
    var swiper = new Swiper('.swiper', {
      pagination: {
        el: '.swiper-pagination',
      },
    });

    if ($('.slab__phantasm').length) {
      mm.add('(max-width:768px)', () => {
        const swiper = new Swiper('.slab__phantasm__swiper', {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
          },
        });

        return () => uspSwiper.destroy(true, true);
      });
    }

    publisherInitScrollReveal();

    // 이미지/폰트 로딩 이후 실제 레이아웃 기준으로 트리거 위치 재계산
    $(window).on('load', function () {
      ScrollTrigger.refresh();
    });
  }

  //260729 제네시스 2 기획전
  if ($('#htmlCustom260724').length) {
    gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);
    const isMobileScroll = window.matchMedia('(max-width: 768px)').matches;

    // 브라우저가 스크롤을 멀티스레드로 처리해서 pin이 걸리고 풀릴 때 튀는 현상 방지
    ScrollTrigger.normalizeScroll(true);

    // compare 테이블 가로 스크롤 영역
    const compareWrap = document.querySelector('.genesis__compare__wrap');
    if (compareWrap) {
      ['touchstart', 'touchmove'].forEach((type) => {
        compareWrap.addEventListener(type, (e) => e.stopPropagation(), { passive: true });
      });
    }

    // 리사이즈 시 ScrollTrigger 재계산
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });

    // 공용: 초기 상태 세팅 후 스크롤 진입 시 노출되는 1회성 트윈 생성
    function revealOnScroll(target, fromVars, toVars, scrollTriggerVars) {
      gsap.set(target, fromVars);
      gsap.to(target, { ...toVars, scrollTrigger: { scrub: 1, once: true, ...scrollTriggerVars } });
    }

    // 히어로 영상 & 커버 인트로
    gsap.from('.genesis__hero__vid video', { duration: 1, scale: 1.2 });

    gsap.to('.genesis__hero__cover', {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.genesis__hero__cover',
        start: 'center top',
        end: '+=80%',
        scrub: 1,
      },
    });

    // 인트로 타이틀(h2/h3/p) SplitText 리빌
    const introTl = gsap.timeline({ paused: true });
    let introH2Ready = false;
    let introH3pReady = false;
    let introTriggerCreated = false;

    function createIntroScrollTriggerOnceReady() {
      if (introTriggerCreated || !introH2Ready || !introH3pReady) return;
      introTriggerCreated = true;

      ScrollTrigger.create({
        trigger: '.genesis__intro__ttl',
        start: 'top 80%',
        animation: introTl,
      });
    }

    // 재분할(autoSplit) 시 이미 재생된 구간이면 .from() 대신 바로 노출 상태로 렌더링
    function revealSplitSegments(tl, position, segments, fromVars) {
      const alreadyPlayed = introTriggerCreated && tl.progress() > 0;
      if (alreadyPlayed) {
        gsap.set(segments, { autoAlpha: 1, yPercent: 0, filter: 'none' });
      } else {
        tl.from(segments, fromVars, position);
      }
    }

    SplitText.create('.genesis__intro__ttl h2', {
      type: 'chars',
      mask: 'chars',
      autoSplit: true,
      onSplit(self) {
        revealSplitSegments(
          introTl,
          0, // timeline 0초 지점 고정
          self.chars,
          {
            autoAlpha: 0,
            yPercent: 80,
            duration: 1,
            filter: 'blur(8px)',
            stagger: 0.02,
          }
        );

        introH2Ready = true;
        createIntroScrollTriggerOnceReady();
      },
    });

    SplitText.create('.genesis__intro__ttl h3, .genesis__intro__ttl p', {
      type: 'lines',
      mask: 'lines',
      autoSplit: true,
      onSplit(self) {
        revealSplitSegments(introTl, '0.5', self.lines, {
          autoAlpha: 0,
          yPercent: 50,
          duration: 0.5,
          stagger: 0.1,
        });

        introH3pReady = true;
        createIntroScrollTriggerOnceReady();
      },
    });

    // 히어로 섹션 pin
    ScrollTrigger.create({
      trigger: '.genesis__hero',
      start: 'top top',
      end: isMobileScroll ? '+=60%' : '+=100%',
      pin: true,
      pinSpacing: isMobileScroll ? true : false,
    });

    // S/LAB ↔ GENESIS 2 라인업 전환 (PC: pin 크로스페이드 / 모바일: 개별 리빌)
    ScrollTrigger.matchMedia({
      '(min-width: 769px)': function () {
        gsap.set('[data-panel="genesis2"] .prd__info', { y: 100, autoAlpha: 0 });
        gsap.set('[data-panel="genesis2"] figure', { y: 50, clipPath: 'inset(0 0 100% 0)', autoAlpha: 0 });

        gsap.from('.slab__vis', {
          scale: 1.2,
          duration: 0.5,
          scrollTrigger: {
            trigger: '.genesis__line',
            start: 'top 80%',
            end: 'center 80%',
            scrub: 0.5,
          },
        });

        gsap
          .timeline({
            scrollTrigger: {
              // markers: { startColor: 'pink', endColor: 'yellow', fontSize: '12px', indent: 20 },
              trigger: '.genesis__line',
              start: 'top 60%',
              end: 'bottom 90%',
              scrub: 0.5,
              invalidateOnRefresh: true,
            },
          })
          .from('[data-panel="slab"] .prd__info', { y: 100, autoAlpha: 0, duration: 0.5 }, 0)
          .from('[data-panel="slab"] figure', { y: 50, clipPath: 'inset(0 0 100% 0)', duration: 0.5 }, 0)
          .to({}, { duration: 0.25 })
          .to('[data-panel="slab"] .prd__info', { y: -50, autoAlpha: 0, duration: 0.25 })
          .to('[data-panel="slab"] figure', { y: -50, autoAlpha: 0, clipPath: 'inset(0 0 100% 0)', duration: 0.25 }, '<');

        const lineTl = gsap.timeline({
          scrollTrigger: {
            //markers: true,
            trigger: '.genesis__line',
            start: 'center center',
            end: 'bottom center',
            pin: true,
            scrub: 0.5,
            invalidateOnRefresh: true,
          },
        });

        lineTl
          .to('.genesis__vis', { autoAlpha: 1, duration: 0.5 })
          .to('[data-panel="genesis2"] .prd__info', { y: 0, autoAlpha: 1, duration: 0.5 }, '<')
          .to('[data-panel="genesis2"] figure', { y: 0, clipPath: 'inset(0 0 0% 0)', autoAlpha: 1, duration: 0.5 }, '<')
          .to({}, { duration: 0.5 });
      },
      '(max-width: 768px)': function () {
        gsap.utils.toArray('.genesis__line__prd').forEach((panel) => {
          const info = panel.querySelector('.prd__info');
          const figure = panel.querySelector('figure');

          revealOnScroll(info, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1 }, { trigger: panel, start: 'top 80%', end: 'top 40%' });
          revealOnScroll(figure, { y: 30, clipPath: 'inset(0 0 100% 0)', autoAlpha: 0 }, { y: 0, clipPath: 'inset(0 0 0% 0)', autoAlpha: 1 }, { trigger: figure, start: 'top bottom', end: 'top 40%' });
        });
      },
    });

    function createUspVisReveal(container, visSelector) {
      revealOnScroll(visSelector, { width: '88vw', borderRadius: '2.5vw' }, { width: '100%', borderRadius: 0 }, { trigger: container, start: 'top 80%', end: 'top 30%', invalidateOnRefresh: true });
    }

    function createUspClipReveal(container) {
      revealOnScroll(container, { clipPath: 'inset(0% 6% round 5vw)' }, { clipPath: 'inset(0% 0% round 0vw)' }, { trigger: container, start: 'top 90%', end: 'top 50%', invalidateOnRefresh: true });
    }

    // 줄바꿈된 SplitText 조각을 줄 단위로 묶어 각 줄만 역순 재배열
    function reverseSegmentsPerLine(segments) {
      const lines = [];
      let lastTop = null;

      segments.forEach((el) => {
        const top = el.offsetTop;
        if (lastTop === null || Math.abs(top - lastTop) > 1) {
          lines.push([]);
          lastTop = top;
        }
        lines[lines.length - 1].push(el);
      });

      return lines.flatMap((line) => line.slice().reverse());
    }

    // USP 단락: step 목록 타임라인 (circle → path → 텍스트 → 디테일 이미지 순으로 등장)
    function createUspTimeline(container, steps, textReverseSteps = []) {
      const stepSplits = {};
      const isTextReverse = (step) => textReverseSteps.includes(step);

      // step별 SplitText 분할 + circle/path/디테일 이미지 초기 상태
      steps.forEach((step) => {
        const meta = (stepSplits[step] = {
          hasCircle: !!document.querySelector(`${container} [data-step="${step}"] svg circle`),
          hasDetail: !!document.querySelector(`${container} [data-step="${step}"] .usp__detail`),
        });

        SplitText.create(`${container} [data-step="${step}"] strong`, {
          type: 'chars',
          autoSplit: true,
          onSplit(self) {
            meta.strongChars = self.chars;
            gsap.set(self.chars, { autoAlpha: 0 });
          },
        });

        SplitText.create(`${container} [data-step="${step}"] p`, {
          type: 'words',
          mask: 'words',
          autoSplit: true,
          onSplit(self) {
            meta.pLines = self.words;
            gsap.set(self.words, { autoAlpha: 0 });
          },
        });

        if (meta.hasCircle) {
          gsap.set(`${container} [data-step="${step}"] svg circle`, { scale: 0, transformOrigin: '50% 50%' });
        }
        gsap.set(`${container} [data-step="${step}"] svg path`, { drawSVG: '0%' });
        if (meta.hasDetail) {
          gsap.set(`${container} [data-step="${step}"] .usp__detail`, { autoAlpha: 0, y: 10 });
        }
      });
      gsap.set(`${container} [data-step]:not([data-step="${steps[0]}"])`, { autoAlpha: 0 });

      // step을 순서대로 잇는 마스터 타임라인
      const tl = gsap.timeline({ paused: true });

      steps.forEach((step, i) => {
        const selector = `${container} [data-step="${step}"]`;
        const { hasCircle, hasDetail, strongChars, pLines } = stepSplits[step];

        if (i > 0) {
          const prevSelector = `${container} [data-step="${steps[i - 1]}"]`;
          tl.to(prevSelector, { autoAlpha: 0, duration: 0.6, ease: 'power1.inOut' });
          tl.set(selector, { autoAlpha: 1 });
        }

        if (hasCircle) {
          tl.to(`${selector} svg circle`, { scale: 1, duration: 0.3, ease: 'back.out(2)' });
        }

        tl.to(`${selector} svg path`, { drawSVG: '100%', duration: 0.7, ease: 'power2.inOut' });

        // reverse step은 줄 단위로 재배열해 첫 줄의 마지막 글자/단어부터 stagger
        const strongTargets = isTextReverse(step) ? reverseSegmentsPerLine(strongChars) : strongChars;
        tl.to(strongTargets, { autoAlpha: 1, duration: 0.5, ease: 'power2.out', stagger: isTextReverse(step) ? 0.05 : 0.02 });

        const pTargets = isTextReverse(step) ? reverseSegmentsPerLine(pLines) : pLines;
        tl.to(pTargets, { autoAlpha: 1, duration: 0.5, ease: 'power2.out', stagger: isTextReverse(step) ? 0.05 : 0.02 }, '-=.2');

        if (hasDetail) {
          tl.to(`${selector} .usp__detail`, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out' }, '-=.3');
        }

        tl.to({}, { duration: 1.5 }); // 모바일은 각 step을 좀 더 오래 보여줌
      });

      return tl;
    }

    // USP 단락: PC 전용 - step을 순차 진행하지 않고 스크롤 도달 시 모든 step을 동시에 리빌
    function createUspRevealAll(container, steps) {
      const stepSplits = {};

      steps.forEach((step) => {
        const meta = (stepSplits[step] = {
          hasCircle: !!document.querySelector(`${container} [data-step="${step}"] svg circle`),
          hasDetail: !!document.querySelector(`${container} [data-step="${step}"] .usp__detail`),
        });

        SplitText.create(`${container} [data-step="${step}"] strong`, {
          type: 'chars',
          autoSplit: true,
          onSplit(self) {
            meta.strongChars = self.chars;
            gsap.set(self.chars, { autoAlpha: 0 });
          },
        });

        SplitText.create(`${container} [data-step="${step}"] p`, {
          type: 'words',
          mask: 'words',
          autoSplit: true,
          onSplit(self) {
            meta.pLines = self.words;
            gsap.set(self.words, { autoAlpha: 0 });
          },
        });

        if (meta.hasCircle) {
          gsap.set(`${container} [data-step="${step}"] svg circle`, { scale: 0, transformOrigin: '50% 50%' });
        }
        gsap.set(`${container} [data-step="${step}"] svg path`, { drawSVG: '0%' });
        if (meta.hasDetail) {
          gsap.set(`${container} [data-step="${step}"] .usp__detail`, { autoAlpha: 0, y: 10 });
        }
      });

      const tl = gsap.timeline({ paused: true });

      steps.forEach((step) => {
        const selector = `${container} [data-step="${step}"]`;
        const { hasCircle, hasDetail, strongChars, pLines } = stepSplits[step];

        if (hasCircle) {
          tl.to(`${selector} svg circle`, { scale: 1, duration: 0.3, ease: 'back.out(2)' }, 0);
        }
        tl.to(`${selector} svg path`, { drawSVG: '100%', duration: 0.7, ease: 'power2.inOut' }, 0);
        tl.to(strongChars, { autoAlpha: 1, duration: 0.5, ease: 'power2.out', stagger: 0.02 }, 0);
        tl.to(pLines, { autoAlpha: 1, duration: 0.5, ease: 'power2.out', stagger: 0.02 }, 0);
        if (hasDetail) {
          tl.to(`${selector} .usp__detail`, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power2.out' }, 0);
        }
      });

      return tl;
    }

    // USP 단락: PC 전용 - 스크롤이 컨테이너에 닿으면 1회 재생 (pin/scrub 없음)
    function createUspRevealTrigger(container, tl) {
      ScrollTrigger.create({
        trigger: container,
        start: container === '.genesis__usp' ? 'top 30%' : 'top 40%',
        end: container === '.genesis__usp' ? 'top top' : 'top 10%',
        animation: tl,
        scrub: 1,
      });
    }

    // USP 단락: 모바일 전용 - step 타임라인을 스크롤에 붙여 pin+scrub으로 순차 재생
    const USP_PIN_MOB = { '.slab__usp': '800% top', '.genesis__usp': '600% top' };

    function createUspMobileScrollTrigger(container, tl) {
      ScrollTrigger.create({
        trigger: container,
        start: 'bottom bottom',
        end: USP_PIN_MOB[container],
        pin: true,
        anticipatePin: 1,
        animation: tl,
        scrub: 1.5,
        invalidateOnRefresh: true,
      });
    }

    // USP 단락: PC/모바일 분기 실행
    ScrollTrigger.matchMedia({
      '(pointer: fine) and (min-width: 769px)': function () {
        createUspVisReveal('.slab__usp', '.slab__usp__vis');
        createUspRevealTrigger('.slab__usp', createUspRevealAll('.slab__usp', ['1', '2', '3', '4', '5']));
        createUspRevealTrigger('.genesis__usp', createUspRevealAll('.genesis__usp', ['1', '2', '3', '4']));
      },

      '(pointer: coarse), (max-width: 768px)': function () {
        createUspClipReveal('.slab__usp');
        createUspMobileScrollTrigger('.slab__usp', createUspTimeline('.slab__usp', ['1', '2', '3', '4', '5'], ['1', '3', '4']));
        createUspMobileScrollTrigger('.genesis__usp', createUspTimeline('.genesis__usp', ['1', '2', '3', '4'], ['1']));
      },
    });
  }

  //260715 하이드레이션 가이드 기획전
  if ($('#htmlCustom260715').length) {
    // ══════════════════════════════════
    //  탭 & 모바일 스와이프 & 페이지네이션 & 상단 고정
    // ══════════════════════════════════
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
    const statItems = document.querySelectorAll('.course-stats .stat-item');

    const grids = Array.from(tabContents).map((c) => c.querySelector('.product-grid'));
    const itemCounts = grids.map((g) => g.children.length); // [2, 3, 3]
    const itemState = [0, 0, 0]; // 탭별 현재 카드 인덱스
    let currentTab = 0;

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    // ── 페이지네이션 준비 ──
    const pagination = document.querySelector('.swipe-pagination');
    const dots = [];

    // 전체 인덱스(0~7) ↔ 탭/카드 매핑
    const flatMap = []; // [{tab:0,item:0}, {tab:0,item:1}, {tab:1,item:0}, ...]
    itemCounts.forEach((count, tab) => {
      for (let item = 0; item < count; item++) flatMap.push({ tab, item });
    });

    if (pagination) {
      flatMap.forEach((pos, i) => {
        const dot = document.createElement('button');
        dot.className = 'dot';
        dot.setAttribute('aria-label', `${i + 1}번째 상품 보기`);
        dot.addEventListener('click', () => goTo(pos.tab, pos.item));
        pagination.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateDots() {
      if (!dots.length) return;
      const globalIndex = flatMap.findIndex((p) => p.tab === currentTab && p.item === itemState[currentTab]);
      dots.forEach((d, i) => d.classList.toggle('active', i === globalIndex));
    }

    // ── 탭 전환 ──
    function activateTab(index) {
      currentTab = index;
      tabBtns.forEach((b) => b.classList.remove('active'));
      tabContents.forEach((c) => c.classList.remove('active'));
      statItems.forEach((s) => s.classList.remove('active'));

      tabBtns[index].classList.add('active');
      tabContents[index].classList.add('active');
      if (statItems[index]) statItems[index].classList.add('active');

      updateDots();
    }

    // ── 슬라이드 적용 ──
    function applySlide() {
      grids.forEach((g, i) => {
        g.style.transform = isMobile() ? `translateX(-${itemState[i] * 100}%)` : '';
      });
      updateDots();
    }

    function goTo(tab, item) {
      itemState[tab] = item;
      activateTab(tab);
      applySlide();
    }

    // ── 다음/이전 카드 (탭 경계 넘으면 탭 전환) ──
    function swipeNext() {
      if (itemState[currentTab] < itemCounts[currentTab] - 1) {
        itemState[currentTab]++;
        applySlide();
      } else if (currentTab < tabContents.length - 1) {
        goTo(currentTab + 1, 0);
      }
    }

    function swipePrev() {
      if (itemState[currentTab] > 0) {
        itemState[currentTab]--;
        applySlide();
      } else if (currentTab > 0) {
        goTo(currentTab - 1, itemCounts[currentTab - 1] - 1); // 이전 탭 마지막 카드
      }
    }

    // ── 스와이프 감지 (터치 + 마우스 드래그) ──
    function addSwipe(el, onLeft, onRight) {
      let sx = 0,
        sy = 0;

      function handleEnd(ex, ey) {
        if (!isMobile()) return;
        const dx = ex - sx;
        const dy = ey - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? onLeft() : onRight();
        }
      }

      // 터치
      el.addEventListener(
        'touchstart',
        (e) => {
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
        },
        { passive: true }
      );
      el.addEventListener(
        'touchend',
        (e) => {
          handleEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        },
        { passive: true }
      );

      // 마우스 드래그
      let dragging = false;
      el.addEventListener('mousedown', (e) => {
        if (!isMobile()) return;
        dragging = true;
        sx = e.clientX;
        sy = e.clientY;
        e.preventDefault(); // 이미지/텍스트 드래그 방지
      });
      window.addEventListener('mouseup', (e) => {
        if (!dragging) return;
        dragging = false;
        handleEnd(e.clientX, e.clientY);
      });
    }

    // ── 이벤트 바인딩 ──

    // 상품 영역 스와이프
    tabContents.forEach((c) => addSwipe(c, swipeNext, swipePrev));

    // 그래프 영역 스와이프 → 탭 단위 이동
    const courseCard = document.querySelector('.course-card');
    if (courseCard) {
      addSwipe(
        courseCard,
        () => {
          if (currentTab < tabContents.length - 1) goTo(currentTab + 1, 0);
        },
        () => {
          if (currentTab > 0) goTo(currentTab - 1, 0);
        }
      );
    }

    // 탭 버튼 클릭 → 해당 탭 첫 카드부터
    tabBtns.forEach((btn, i) => {
      btn.addEventListener('click', () => goTo(i, 0));
    });

    // 리사이즈 시 transform 정리
    window.addEventListener('resize', applySlide);

    // 초기 상태
    updateDots();

    // ══════════════════════════════════
    //  탭 버튼 상단 고정 (fixed 방식)
    // ══════════════════════════════════
    const sectionFinder = document.querySelector('.section-finder');
    const tabButtonsEl = document.querySelector('.tab-buttons');

    // 사이트 고정 헤더가 있으면 그 높이(px)를 넣어주세요
    const HEADER_OFFSET = 0;

    if (sectionFinder && tabButtonsEl) {
      // fixed 시 레이아웃 밀림 방지용 placeholder
      const placeholder = document.createElement('div');
      placeholder.style.display = 'none';
      tabButtonsEl.parentNode.insertBefore(placeholder, tabButtonsEl);

      let isFixed = false;

      function fixTabs() {
        const btnHeight = tabButtonsEl.offsetHeight;
        placeholder.style.height = btnHeight + 'px';
        placeholder.style.display = 'block';

        tabButtonsEl.style.position = 'fixed';
        tabButtonsEl.style.top = HEADER_OFFSET + 'px';
        tabButtonsEl.style.left = '50%';
        tabButtonsEl.style.transform = 'translateX(-50%)';
        tabButtonsEl.style.width = '100%';
        tabButtonsEl.style.maxWidth = '1600px';
        tabButtonsEl.style.padding = '10px 20px';
        tabButtonsEl.style.zIndex = '100';
        tabButtonsEl.style.background = '#000';
        tabButtonsEl.style.boxSizing = 'border-box';
        isFixed = true;
      }

      function unfixTabs() {
        placeholder.style.display = 'none';
        tabButtonsEl.removeAttribute('style');
        isFixed = false;
      }

      function handleStickyTabs() {
        // fixed 상태일 땐 placeholder 위치 기준으로 판정
        const anchor = isFixed ? placeholder : tabButtonsEl;
        const anchorTop = anchor.getBoundingClientRect().top;
        const sectionBottom = sectionFinder.getBoundingClientRect().bottom;
        const btnHeight = tabButtonsEl.offsetHeight;

        const shouldFix = anchorTop <= HEADER_OFFSET && sectionBottom > btnHeight + HEADER_OFFSET;

        if (shouldFix && !isFixed) fixTabs();
        if (!shouldFix && isFixed) unfixTabs();
      }

      window.addEventListener('scroll', handleStickyTabs, { passive: true });
      window.addEventListener('resize', handleStickyTabs);
      handleStickyTabs();
    }

    //scroll motion
    $(window).on('load', function () {
      gsap.to('.section-visual-ttl', { autoAlpha: 1, duration: 0.5 });
      gsap.to('.section-visual-ttl h1', { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.2 });
      gsap.to('.section-visual-ttl p', { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.2 });
    });

    $('.img-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      cssEase: 'linear',
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            // 모바일: 스와이프/드래그 활성
            swipe: true,
            draggable: true,
            touchMove: true,
            pauseOnHover: false,
            pauseOnFocus: false,
          },
        },
      ],
    });

    //scroll motion
    $(window).on('load scroll', function () {
      $('.box, .section-btm, .new-area > *').each(function () {
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });

    // ══════════════════════════════════
    //  Video 지연 로딩 이벤트
    // ══════════════════════════════════
    const lazyVideos = document.querySelectorAll('video[data-video-src]');

    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            // 실제 src가 없다면 이 시점에 주입
            if (!video.src && video.dataset.videoSrc) {
              video.src = video.dataset.videoSrc;
              video.load(); // 명시적으로 로드 트리거
            }

            video.play().catch((err) => {
              // 자동재생 정책으로 재생 실패 시 조용히 무시 (poster 이미지가 대신 보여짐)
              console.warn('영상 자동재생 실패:', err);
            });
          } else {
            // 화면에서 벗어나면 일시정지 (배터리/CPU 절약, 재생 위치는 유지됨)
            if (!video.paused) {
              video.pause();
            }
          }
        });
      },
      {
        rootMargin: '200px', // 화면에 도달하기 200px 전부터 미리 로드 시작
        threshold: 0.1, // 10% 정도 보이면 트리거
      }
    );

    lazyVideos.forEach((video) => videoObserver.observe(video));
  }
  
  //260702 하이드레이션 가이드 기획전
  if($('#htmlCustom260702').length){
    // ══════════════════════════════════
    //  탭 & 모바일 스와이프 & 페이지네이션 & 상단 고정
    // ══════════════════════════════════
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
    const statItems = document.querySelectorAll('.course-stats .stat-item');

    const grids = Array.from(tabContents).map(c => c.querySelector('.product-grid'));
    const itemCounts = grids.map(g => g.children.length); // [2, 3, 3]
    const itemState = [0, 0, 0]; // 탭별 현재 카드 인덱스
    let currentTab = 0;

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    // ── 페이지네이션 준비 ──
    const pagination = document.querySelector('.swipe-pagination');
    const dots = [];

    // 전체 인덱스(0~7) ↔ 탭/카드 매핑
    const flatMap = []; // [{tab:0,item:0}, {tab:0,item:1}, {tab:1,item:0}, ...]
    itemCounts.forEach((count, tab) => {
      for (let item = 0; item < count; item++) flatMap.push({ tab, item });
    });

    if (pagination) {
      flatMap.forEach((pos, i) => {
        const dot = document.createElement('button');
        dot.className = 'dot';
        dot.setAttribute('aria-label', `${i + 1}번째 상품 보기`);
        dot.addEventListener('click', () => goTo(pos.tab, pos.item));
        pagination.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateDots() {
      if (!dots.length) return;
      const globalIndex = flatMap.findIndex(
        p => p.tab === currentTab && p.item === itemState[currentTab]
      );
      dots.forEach((d, i) => d.classList.toggle('active', i === globalIndex));
    }

    // ── 탭 전환 ──
    function activateTab(index) {
      currentTab = index;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      statItems.forEach(s => s.classList.remove('active'));

      tabBtns[index].classList.add('active');
      tabContents[index].classList.add('active');
      if (statItems[index]) statItems[index].classList.add('active');

      updateDots();
    }

    // ── 슬라이드 적용 ──
    function applySlide() {
      grids.forEach((g, i) => {
        g.style.transform = isMobile()
          ? `translateX(-${itemState[i] * 100}%)`
          : '';
      });
      updateDots();
    }

    function goTo(tab, item) {
      itemState[tab] = item;
      activateTab(tab);
      applySlide();
    }

    // ── 다음/이전 카드 (탭 경계 넘으면 탭 전환) ──
    function swipeNext() {
      if (itemState[currentTab] < itemCounts[currentTab] - 1) {
        itemState[currentTab]++;
        applySlide();
      } else if (currentTab < tabContents.length - 1) {
        goTo(currentTab + 1, 0);
      }
    }

    function swipePrev() {
      if (itemState[currentTab] > 0) {
        itemState[currentTab]--;
        applySlide();
      } else if (currentTab > 0) {
        goTo(currentTab - 1, itemCounts[currentTab - 1] - 1); // 이전 탭 마지막 카드
      }
    }

    // ── 스와이프 감지 (터치 + 마우스 드래그) ──
    function addSwipe(el, onLeft, onRight) {
      let sx = 0, sy = 0;

      function handleEnd(ex, ey) {
        if (!isMobile()) return;
        const dx = ex - sx;
        const dy = ey - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? onLeft() : onRight();
        }
      }

      // 터치
      el.addEventListener('touchstart', e => {
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      el.addEventListener('touchend', e => {
        handleEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      }, { passive: true });

      // 마우스 드래그
      let dragging = false;
      el.addEventListener('mousedown', e => {
        if (!isMobile()) return;
        dragging = true;
        sx = e.clientX;
        sy = e.clientY;
        e.preventDefault(); // 이미지/텍스트 드래그 방지
      });
      window.addEventListener('mouseup', e => {
        if (!dragging) return;
        dragging = false;
        handleEnd(e.clientX, e.clientY);
      });
    }

    // ── 이벤트 바인딩 ──

    // 상품 영역 스와이프
    tabContents.forEach(c => addSwipe(c, swipeNext, swipePrev));

    // 그래프 영역 스와이프 → 탭 단위 이동
    const courseCard = document.querySelector('.course-card');
    if (courseCard) {
      addSwipe(courseCard,
        () => { if (currentTab < tabContents.length - 1) goTo(currentTab + 1, 0); },
        () => { if (currentTab > 0) goTo(currentTab - 1, 0); }
      );
    }

    // 탭 버튼 클릭 → 해당 탭 첫 카드부터
    tabBtns.forEach((btn, i) => {
      btn.addEventListener('click', () => goTo(i, 0));
    });

    // 리사이즈 시 transform 정리
    window.addEventListener('resize', applySlide);

    // 초기 상태
    updateDots();


    // ══════════════════════════════════
    //  탭 버튼 상단 고정 (fixed 방식)
    // ══════════════════════════════════
    const sectionFinder = document.querySelector('.section-finder');
    const tabButtonsEl = document.querySelector('.tab-buttons');

    // 사이트 고정 헤더가 있으면 그 높이(px)를 넣어주세요
    const HEADER_OFFSET = 0;

    if (sectionFinder && tabButtonsEl) {
      // fixed 시 레이아웃 밀림 방지용 placeholder
      const placeholder = document.createElement('div');
      placeholder.style.display = 'none';
      tabButtonsEl.parentNode.insertBefore(placeholder, tabButtonsEl);

      let isFixed = false;

      function fixTabs() {
        const btnHeight = tabButtonsEl.offsetHeight;
        placeholder.style.height = btnHeight + 'px';
        placeholder.style.display = 'block';

        tabButtonsEl.style.position = 'fixed';
        tabButtonsEl.style.top = HEADER_OFFSET + 'px';
        tabButtonsEl.style.left = '50%';
        tabButtonsEl.style.transform = 'translateX(-50%)';
        tabButtonsEl.style.width = '100%';
        tabButtonsEl.style.maxWidth = '1600px';
        tabButtonsEl.style.padding = '10px 20px';
        tabButtonsEl.style.zIndex = '100';
        tabButtonsEl.style.background = '#000';
        tabButtonsEl.style.boxSizing = 'border-box';
        isFixed = true;
      }

      function unfixTabs() {
        placeholder.style.display = 'none';
        tabButtonsEl.removeAttribute('style');
        isFixed = false;
      }

      function handleStickyTabs() {
        // fixed 상태일 땐 placeholder 위치 기준으로 판정
        const anchor = isFixed ? placeholder : tabButtonsEl;
        const anchorTop = anchor.getBoundingClientRect().top;
        const sectionBottom = sectionFinder.getBoundingClientRect().bottom;
        const btnHeight = tabButtonsEl.offsetHeight;

        const shouldFix =
          anchorTop <= HEADER_OFFSET &&
          sectionBottom > btnHeight + HEADER_OFFSET;

        if (shouldFix && !isFixed) fixTabs();
        if (!shouldFix && isFixed) unfixTabs();
      }

      window.addEventListener('scroll', handleStickyTabs, { passive: true });
      window.addEventListener('resize', handleStickyTabs);
      handleStickyTabs();
    }

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual h1').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.9) {
          $(this).addClass('active');
        }
      });
    });
    
    $('.img-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      cssEase: 'linear',
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 768, 
          settings: {
            slidesToShow: 1,
            // 모바일: 스와이프/드래그 활성
            swipe: true,
            draggable: true,
            touchMove: true,
            pauseOnHover: false,
            pauseOnFocus: false
          }
        }
      ]
    });

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual, .box, .section-btm, .new-area > *').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260518 그래블 러닝 어페럴 2
  if($('#htmlCustom260518').length){
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual, .box, .section-btm, .new-area > *').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });
  }
  
  //260417 러닝커뮤니티
  if($('#htmlCustom260417').length){
    function updateBoxStatus() {
      const boxes = document.querySelectorAll('.apply-section .box');
      const now = new Date();

      boxes.forEach(box => {
        const startStr = box.dataset.start;
        const endStr   = box.dataset.end;

        // data-start / data-end 없으면 스킵
        if (!startStr || !endStr) return;

        const startDate = new Date(startStr);
        const endDate   = new Date(endStr);

        // 기존 상태 클래스 초기화
        box.classList.remove('ready', 'start', 'closed');

        if (now < startDate) {
          // 신청 시작 전
          box.classList.add('ready');
          // 신청 예정으로 텍스트 변경
          const link = box.querySelector('.btn-html');
          //if (link) link.textContent = '오픈예정';
          if (link) link.textContent = '미리보기';

        } else if (now >= startDate && now < endDate) {
          // 신청 진행 중
          box.classList.add('start');
        } else {
          // 신청 종료
          box.classList.add('closed');
          const link = box.querySelector('.btn-html');
          if (link) link.textContent = '응모종료';
        }
      });
    }

    // 페이지 로드 시 즉시 실행
    updateBoxStatus();

    // 10분마다 상태 갱신
    setInterval(updateBoxStatus, 60 * 1000);
  }
});
